<div style="max-height: 78vh;">
    <angular-editor [(ngModel)]="htmlContent" [config]="config"></angular-editor>
    <div class="row">
        <div class="col-12 d-flex justify-content-center mt-2">
            <button class="btn btn-primary" (click)="onSubmit()">{{'filesystem.upload'|translate}}</button>
        </div>
    </div>
</div>